import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getNormalizedUrl } from "../../getNormalizedUrl";
import { FAIRE_SPAN_ID_TRACKING, TelemetryManager } from "../../opentelemetry/TelemetryManager";
import { getSettingEnableDetailedSessionTracing } from "../../settings/getSettingEnableDetailedSessionTracing";
var ENDPOINT_EXCLUSION_LIST = [
    "client-event",
    "client-events",
    "v2/events"
];
export var opentelemetryRequestInterceptor = function(config) {
    var _TelemetryManager_get_getActiveTraceHeaders;
    if (ENDPOINT_EXCLUSION_LIST.some(function(excluded_endpoint) {
        return config.url.includes(excluded_endpoint);
    }) || !getSettingEnableDetailedSessionTracing()) {
        return config;
    }
    var spanName = "".concat(config.method, " ").concat(getNormalizedUrl(config.url));
    var spanId = TelemetryManager.get().startManagedSpan(spanName, {
        kind: "client",
        name: spanName,
        // specifically avoiding `http.method` to avoid conflicts with the DD OTel instrumentation.
        "http.request_method": config.method,
        "http.url": config.url,
        resource_name: "".concat(config.method, "_").concat(config.url).toLocaleLowerCase(),
        "service-group": "http_request",
        service: "http_request"
    });
    var traceparent = (_TelemetryManager_get_getActiveTraceHeaders = TelemetryManager.get().getActiveTraceHeaders()) === null || _TelemetryManager_get_getActiveTraceHeaders === void 0 ? void 0 : _TelemetryManager_get_getActiveTraceHeaders.traceparent;
    var _obj;
    return _object_spread_props(_object_spread({}, config), {
        headers: _object_spread_props(_object_spread({}, config.headers), (_obj = {}, _define_property(_obj, FAIRE_SPAN_ID_TRACKING, spanId), _define_property(_obj, "traceparent", traceparent), _obj))
    });
};
